import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { memberService } from '../services/memberService';
import { registrationCheckService } from "../services/registrationCheckService";
import ConfirmForm from '../components/MemberRegistrationConfirmForm';
import '../assets/css/common.css';
import styles from '../assets/css/member-registration.module.css';
import CustomButtons from '../components/CustomButtons';

function MemberRegistrationConfirm() {
  const location = useLocation();
  const navigate = useNavigate();
  const { formData, familyMembers } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);

   useEffect(() => {
    const checkAlreadyRegistered = async () => {
      try {
        const result = await registrationCheckService.checkRegistration();
        if (result?.hasMemberData) {
          navigate('/route-check'); // すでに登録済みなら次ページに遷移
        }
      } catch (error) {
        console.error('登録確認エラー:', error);
      } finally {
        setChecking(false);
      }
    };

    checkAlreadyRegistered();
  }, [navigate]);

    useEffect(() => {
    if (formData && familyMembers) {
      sessionStorage.setItem('formData', JSON.stringify(formData));
      sessionStorage.setItem('familyMembers', JSON.stringify(familyMembers));
    }
  }, [formData, familyMembers]);


  const handleSave = async () => {

    if (loading) return;  // 連打防止
    setLoading(true);

    try {
      await memberService.save({ formData, familyMembers });
      sessionStorage.removeItem('formData');
      sessionStorage.removeItem('familyMembers');
      navigate('/route-check');
    } catch (error) {
      alert(error.message || '保存に失敗しました。');
    } finally {
    setLoading(false);
    }
  };

  if (!formData) {
    return <p>データが見つかりませんでした。</p>;
  }

  return (
    <div className={styles.mainContents}>
      <div className={styles.container}>
        <ConfirmForm formData={formData} familyMembers={familyMembers} />

        <CustomButtons
          leftLabel="修正する"
          rightLabel="確定して交通経路登録へ"
          rightLoadingLabel="登録中..."
          onLeftClick={() =>
            navigate('/member-registration', {
              state: {
                formData,
                familyMembers
              }
            })
          }
          onRightClick={handleSave}
          rightDisabled={loading}
          rightLoading={loading}
        />
      </div>
    </div>
  );
}

export default MemberRegistrationConfirm;
